import { PlanNamesType } from "@hz/stealthy-gmc-cloaker-common/constants";
import { api, Tags } from "../..";
import {CreateCheckoutSessionParams, UpgradePlanParams} from "@hz/stealthy-gmc-cloaker-common/api-types/checkout"
import { RegisterParams } from "@hz/stealthy-gmc-cloaker-common/api-types/auth";
import {UsersResponse } from "@hz/stealthy-gmc-cloaker-common/api-types/user"

export interface HasActiveSubscriptionResponse {
  hasActiveSubscription: boolean;
}

export interface HasActiveSubscriptionParams {
  mondayAccountId: string;
}

const usersRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    inviteSubUser: build.mutation<{success: boolean}, RegisterParams>({
      query: ({ email, role, name }) => ({
        url: `/sub-user/invite`,
        body: {
          email,
          name,
          role,
        },
        method: "POST",
      }),
      invalidatesTags: [Tags.Users],
    }),
    getSubUsers: build.query<UsersResponse, {}>({
      query: () => ({
        url: `/sub-user`,
       
      }),
      providesTags: [Tags.Users],
    }),
    deleteSubUser: build.mutation<{success: boolean}, {userId: string}>({
      query: ({ userId }) => ({
        url: `/sub-user/delete/${userId}`,
       
        method: "DELETE",
      }),
      invalidatesTags: [Tags.Users],
    }),
    resendSubUserInvite: build.mutation<{success: boolean}, {userId: string}>({
      query: ({ userId }) => ({
        url: `/sub-user/invite/resend/${userId}`,
        method: "POST",
      }),

    }),
  }),
});

export default usersRequestsSlice;
